import script from "./studentList.vue?vue&type=script&setup=true&lang=js"
export * from "./studentList.vue?vue&type=script&setup=true&lang=js"

import "./studentList.vue?vue&type=style&index=0&id=6492b7ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6492b7ec"]])

export default __exports__